import axiosClient from "../utils/axios";

export default function ({ id }: { id: any }) {
  return axiosClient
    .post(`/lend-orders/single/offers/cancel`, {
      id: id,
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return Promise.reject(error);
    });
}
